/*
 * View for the Standard Response publish modal
 */

define(["marionette", "./template/standardResponsePublishModalTemplate.html"], function (
  Marionette,
  StandardResponsePublishModalTemplate,
) {
  var StandardResponsePublishModalView = {};

  StandardResponsePublishModalView.standardResponsePublishModalLayout = Marionette.Layout.extend({
    template: StandardResponsePublishModalTemplate,
    regions: {
      pendingResponseList: "#pendingResponseList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#pendingResponseError").hide();
    },
    showError: function () {
      this.$el.find("#pendingResponseError").attr("data-i18n", "topic.publish.error").i18n().show();
    },
    hideWarning: function () {
      this.$el.find("#pendingResponseError").hide();
    },
    showWarning: function () {
      this.$el
        .find("#pendingResponseError")
        .attr("data-i18n", "topic.publish.disabled")
        .i18n()
        .show();
    },
  });

  return StandardResponsePublishModalView;
});
